import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  menuAnatomy.keys,
);

const albumOpBaseStyle = definePartsStyle({
  list: {
    bg: "rgba(8, 8, 8, 0.8)",
    color: "text.secondary",
    border: "1px solid",
    borderColor: "bg.boardBg",
    maxH: "300px",
    pos: "relative",
    rounded: "4px",
    minW: "120px",
  },
  item: {
    px: "32px",
    py: "6px",
    color: "text.secondary",
    bg: "rgba(8, 8, 8, 0.8)",
    _hover: {
      bg: "bg.panelBg",
    },
    _focus: {},
  },
});

// define the base component styles
const creatorAlbumOpStyle = definePartsStyle({
  // define the part you're going to style
  button: {
    position: "absolute",
    top: "6px",
    right: "8px",
    rounded: "4px",
    _active: {
      bg: "text.primary",
    },
  },
  list: {
    w: "126px",
    py: "12px",
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.25)",
    border: "none",
    bg: "rgba(50, 50, 50, 1)",
  },
  item: {
    fontSize: "14px",
    py: "8px",
    pl: "20px",
    bg: "rgba(50, 50, 50, 1)",
    color: "#B3B3B3",
    _hover: {
      bg: "text.primary",
    },
  },
});

const creatorAlbumMoveImageMenuStyle = definePartsStyle({
  list: {
    w: "150px",
    bg: "bg.panelBg",
    borderColor: "#585858",
    // pb: "10px",
  },
  item: {
    fontSize: "16px",
    py: "6px",
    px: "10px",
    color: "#dcdcdc",
    bg: "bg.panelBg",
    _hover: {
      bg: "text.primary",
      color: "brand.hover",
    },
  },
});

const spaceAlbumMoveImage = definePartsStyle({
  list: {
    // py: "8px",
    rounded: "8px",
    w: "276px",
    border: "1px solid",
    borderColor: "bg.panelBg",
  },
  item: {
    pl: "32px",
  },
});

const galleryDetailModalMoveImage = definePartsStyle({
  list: {
    w: "150px",
  },
  item: {
    pl: "10px",
  },
});

export const albumOpStyle = defineMultiStyleConfig({
  baseStyle: albumOpBaseStyle,
  variants: {
    creatorAlbumOp: creatorAlbumOpStyle,
    creatorMoveImage: creatorAlbumMoveImageMenuStyle,
    spaceMoveImage: spaceAlbumMoveImage,
    galleryDetailModalMoveImage,
  },
});

export type AlbumOperationMenuVariantType =
  | "creatorAlbumOp"
  | "creatorMoveImage"
  | "spaceMoveImage"
  | "galleryDetailModalMoveImage";
